var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.brandName)+", "+_vm._s(_vm.year))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }